import React, { useEffect, useState } from 'react'
import ReactPlayer from 'react-player'
import "./VideoPlayer.css"
import $ from 'jquery'
const VideoPlayer = (props: any) => {


    const [blockEnter, setBlockEnter] = useState<any>("hideInfo");



    useEffect(() => {
        $(document).ready(function() {
            $('.hideInfo').bind('touchstart touchend', function(e) {
                e.preventDefault();
                $(this).toggleClass('hideInfo');
            });
        });
      
    }, [])
    return (

        // Lazy load the YouTube player
        <>
            <div className={blockEnter}
             onPointerEnter={()=>{setBlockEnter("hideInfo")}}
            ></div>
            <div className='videowrapper' 
            onTouchStart={()=>{setBlockEnter("hideInfo")}}
            onTouchEnd={()=>{setBlockEnter("showInfo")}}
            onPointerEnter={()=>{setBlockEnter("hideInfo")}}
            onPointerLeave={()=>{setBlockEnter("showInfo")}}
            >


                <ReactPlayer id="resdad"


                    style={{ width: '100% !important'}}
                    
                    url={`'https://www.youtube.com/watch?v=${props.video_path}?autoplay=1&rel=0&showinfo=0'`} playing={false} controls={true}

                    config={{
                        youtube: {
                            playerVars: { showinfo: 0, modestbranding: 1, autoplay: 1, disablekb: 1 }
                        },

                    }}

                />
            </div>
        </>
    )
}


export default VideoPlayer